import React, { useState } from "react";
import "./agentmodal.css";
import { Modal } from "react-bootstrap";
import { message } from "antd";
import Instance from "../../../AxiosConfig";
import { Spin } from "antd";
const AddAgentModal = ({ show, handleClose,fetchData }) => {
  const [name, setName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const handleSave = async () => {
    try {
      setLoading(true);
      // const token = localStorage.getItem("token"); // ✅ Retrieve token from localStorage

      const response = await Instance.post(
        "/agents",
        {
          agentName: name,
          agentEmail: email,
          agentNumber: mobileNumber,
        },
       
      );
      console.log(response);
      // ✅ Show success message if API call succeeds
      if (response.status == 200 || response.status == 201) {
        message.open({
          type: "success",
          content: "New Agent added successfully!",
          className: "custom-add-agent-toast",
        });
        handleClose();
        setName("");
        setEmail("");
        setMobileNumber("");
        fetchData(); // Refresh the agents list
      }
      setLoading(false);
    } catch (error) {
      console.error("Error adding agent:", error);
      message.error("Failed to add agent. Please try again.");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      centered
      backdrop="static"
      dialogClassName="custom-agent-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Add New Agent</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <form>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 mb-3">
                <label className="form-label">Agent Name</label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)} // ✅ Controlled input
                  className="form-control"
                  placeholder="Enter agent name"
                />
              </div>

              <div className="col-md-12 mb-3">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)} // ✅ Controlled input
                  className="form-control"
                  placeholder="Enter email"
                />
              </div>

              <div className="col-md-12 mb-3">
                <label className="form-label">Mobile Number</label>
                <input
                  type="tel"
                  value={mobileNumber}
                  onChange={(e) => setMobileNumber(e.target.value)} // ✅ Controlled input
                  className="form-control"
                  placeholder="Enter mobile number"
                />
              </div>

              <div className="d-flex justify-content-end gap-2 mt-3">
                <button
                  type="button"
                  className="users-discard-button"
                  onClick={handleClose}
                >
                  Discard
                </button>
                <button
                  type="button"
                  className="users-save-button d-flex align-items-center justify-content-center"
                  onClick={handleSave}
                  disabled={loading} // disable when loading
                  style={{ minWidth: "100px" }}
                >
                  {loading ? (
                    <>
                      <Spin size="small" /> &nbsp;Saving...
                    </>
                  ) : (
                    "Save"
                  )}
                </button>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default AddAgentModal;
